import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.List.IRequest;
type Response = Api.Core.StatementBalance.List.IResponse;
type Headers = Api.Core.StatementBalance.List.IHeaders;
const url = '/api/DealerManagement/StatementBalance';
export default async function statementBalanceListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
